/**
 * Created by r4zi4l on 17.03.2021
 */

const InfoComponent = function (unit) { 
    UnitComponent.call(this, unit);
};

InfoComponent.prototype = Object.create(UnitComponent.prototype);
InfoComponent.prototype.constructor = InfoComponent;

InfoComponent.prototype.getActionInfo = function () {
    const info = {
        title: cleverapps.unitsLibrary.getUnitName(this.unit)
    };

    const data = this.unit.getData().info;
    if (data.guide) {
        if (!data.guideOptions.bundle && !data.guideOptions.getGuideBundle) {
            data.guideOptions.bundle = bundles[`${data.guideOptions.name}_${cleverapps.meta.selectedLocationId()}`];
        }
        info.windowParameters = {
            unit: this.unit,
            guideOptions: data.guideOptions
        };
    }

    if (data.landmarkDonor) {
        info.windowParameters = {
            landmark: Map2dLocation.currentLocation.landmarks.findDonorLandmark(this.unit)
        };
    }

    if (data.description) {
        info.description = Messages.get(data.description);
    }

    return info;
};
